
import React from 'react';

import IOption from '../../interfaces/IOption';
import HorizontalRadioButton from '../HorizontalRadioButton';

import styles from './styles.module.scss';

interface IRadioButtonsGroup {
  selected?: IOption | null;
  setSelected(selected: IOption): void;
  options: IOption[];
  text?: string;
  className?: string; 
}

const HorizontalRadioButtons = ({ 
  selected, setSelected, options,
  text, className
}: IRadioButtonsGroup) => {
  const renderOptions = () => {
    return options.map((option) => {
      return (
        <HorizontalRadioButton 
          key={typeof option.value === 'string' ? option.value : option.label}
          isChecked={option.value === selected?.value}
          radioButton={option}
          setSelected={setSelected} 
        />
      )
    });
  } 

  const renderButtons = () => {
    return (
      <div className={`${styles.radioButtons}`} >
        <div className={styles.radioButtonsGroup}>
          { renderOptions() }
        </div>
      </div>
    )
  }

  if (text) {
    return (
      <div className={`${styles.typeHolder} ${className}`}>
        <p className={styles.typeHeader}>{ text }</p>

        { renderButtons() }
      </div>
    )
  }

  return (
    <>{ renderButtons() }</>
  )
}

export default HorizontalRadioButtons;